// React
import React, { useState, useEffect, useRef } from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';
import useMounted from '../../../hooks/useMounted';

// Third party
import { useParams } from 'react-router-dom';

// Data types
import {
  standardFeatureCore,
  standardFeatureDetail
} from '../../../data-types/standardFeature';
import eventBus from '../../../shared/eventBus';

// This component
export default function StandardFeatureDetail() {
  const { itemId } = useParams();
  const isNewItem = itemId === 'new';

  // Data types
  const { endpointByTrim, getDetailId } = standardFeatureCore();
  const {
    baseUrl,
    getInputs,
    watchedParameters,
    generateStandardFeatureCode
  } = standardFeatureDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  const mounted = useMounted();

  const generateStandardFeatureCodeRef = useRef(generateStandardFeatureCode);
  const watchedParametersRef = useRef(watchedParameters);

  const [generatedValues, setGeneratedValues] = useState({
    generateStandardFeatureCode: null
  });

  useEffect(()=>{

    for (let key in watchedParametersRef.current) {

      eventBus.on(`formInputChange_${key}`, (data_) => {

        if(
          mounted.current &&
          watchedParametersRef.current.hasOwnProperty(data_.parameter)
        ) {

          watchedParametersRef.current[key] = data_;

          const generateStandardFeatureCode = generateStandardFeatureCodeRef.current(
            watchedParametersRef.current['yearId'],
            watchedParametersRef.current['trimId'],
          );

          setGeneratedValues({
            generateStandardFeatureCode: generateStandardFeatureCode
          });

        }

      });

    }

  },[mounted]);


  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'data-type',
        title: 'Standard Feature',
        // Static
        itemId,
        isNewItem,
        endpoint: endpointByTrim,
        baseUrl,
        getDetailId,
        getInputs,
        generatedValues,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper />
    </DetailContext.Provider>
  );
}
